import React from "react";
import { Link } from "react-router-dom";
export default function NotFound() {
  return (
    <main className="max-w-3xl mx-auto px-4 py-24 text-center">
      <div className="font-display text-7xl font-bold text-[#004BCA]">404</div>
      <h1 className="font-display text-2xl font-bold mt-3">Page not found</h1>
      <p className="text-slate-500 mt-2">The page you're looking for doesn't exist.</p>
      <Link data-testid="notfound-home" to="/" className="btn-primary-sf inline-flex mt-6 px-6 py-2.5 rounded-full text-sm font-semibold">Back to home</Link>
    </main>
  );
}
